import {
    ReplyContentAudioDTO,
    ReplyContentAudioVoiceDTO,
    ReplyContentDocumentDTO,
    ReplyContentErrorDTO,
    ReplyContentImageDTO,
    ReplyContentTextDTO,
    ReplyContentVideoDTO,
} from '../api/gen/base'
import { RegularRequestFormFile } from '../components/RegularRequestForm/RegularRequestForm'

type ReplyContent =
    | ReplyContentTextDTO
    | ReplyContentAudioVoiceDTO
    | ReplyContentImageDTO
    | ReplyContentVideoDTO
    | ReplyContentAudioDTO
    | ReplyContentDocumentDTO
    | ReplyContentErrorDTO

export const getTextContentFromReplyContent = (content: ReplyContent[]) =>
    content.find(({ content_type }) => content_type === 'TEXT') as ReplyContentTextDTO | undefined

export const getRegularRequestFormFilesFromReplyContent = (
    content: ReplyContent[],
): RegularRequestFormFile[] =>
    content.filter(
        (value) =>
            value.content_type !== 'ERROR' &&
            value.content_type !== 'AUDIO_VOICE' &&
            value.content_type !== 'TEXT',
    )

export const splitRegularRequestFormFiles = (files: RegularRequestFormFile[]) => {
    const fileUrls: string[] = []
    const newFiles: File[] = []

    files.forEach((file) => {
        if ('name' in file) {
            newFiles.push(file)
        } else {
            if ('image_url' in file && file.image_url) {
                fileUrls.push(file.image_url)
            } else if ('video_url' in file && file.video_url) {
                fileUrls.push(file.video_url)
            } else if ('audio_url' in file && file.audio_url) {
                fileUrls.push(file.audio_url)
            } else if ('file_url' in file) {
                fileUrls.push(file.file_url)
            }
        }
    })

    return {
        fileUrls,
        newFiles,
    }
}

export const getRegularRequestFormStartDate = (date: Date) => {
    const fifteenMinutes = 1000 * 60 * 15

    return new Date(Math.ceil(date.getTime() / fifteenMinutes) * fifteenMinutes)
}
